import { george, pr, React, theme, ui } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { IOfferConditionsResponse } from "types/offer";
import {
    SMART_SPAREN_PRODUCT_CODE,
    SPARK7_PRODUCT_CODE,
} from "../../JuniorStore";
import { JuniorTextButton } from "../JuniorTextButton";
import { JuniorPillBadge } from "./JuniorPillBadge";

// Function to get product image based on productCode
const getProductImage = (productCode: string): string => {
    switch (productCode) {
        case SMART_SPAREN_PRODUCT_CODE:
            // Smart Sparen - piggy bank image
            return require("../../../../assets/gJunior/gjunior_smart_saving_icon.svg");
        case SPARK7_PRODUCT_CODE:
            // Spark 7 - payment card image
            return require("../../../../assets/gJunior/Spark7.svg");
        default:
            // Default fallback image
            return require("../../../../assets/gJunior/child_icon_boy.svg");
    }
};

// Function to get background color for product image
const getProductImageBackground = (productCode: string): string => {
    switch (productCode) {
        case SMART_SPAREN_PRODUCT_CODE:
            return "#faf2f8";
        case SPARK7_PRODUCT_CODE:
            return "#19737b";
        default:
            return "transparent";
    }
};

export type ProductCardProps = {
    title: string;
    description: string;
    onClick?: () => void;
    isNew?: boolean;
    productCode: string;
    isAvailable?: boolean;
    reason?: string;
    conditions?: IOfferConditionsResponse;
    isNewProduct?: boolean;
    /** „Empfohlen“ / „Recommended“ — only used for Smart Sparen in the new-products section. */
    showRecommendedBadge?: boolean;
    onOpenAccountButtonCLick?: () => void;
    onProductDetailsClick?: () => void;
    onFeeInformationClick?: () => void;
};

export const ProductCard: React.FC<ProductCardProps> = (props) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;
    const isSpark7 = SPARK7_PRODUCT_CODE === props.productCode;
    const isDark = ui.isDarkMode;

    const primaryButtonBg = isDark
        ? theme.themeColors.d_blue_100
        : theme.themeColors.blue_300;
    const linkColor = isDark
        ? theme.themeColors.d_blue_100
        : theme.themeColors.blue_300;

    return (
        <george.Card
            elevated={false}
            style={{
                borderRadius: 8,
                padding: theme.MARGIN,
                marginBottom: theme.MARGIN_SMALL,
                cursor:
                    !props.isNewProduct && props.onClick
                        ? "pointer"
                        : "default",
            }}
            onClick={!props.isNewProduct ? props.onClick : undefined}
        >
            <div style={{ display: "flex", alignItems: "center" }}>
                <div
                    style={{
                        width: 100,
                        height: 100,
                        borderRadius: 8,
                        flexShrink: 0,
                        backgroundColor: getProductImageBackground(
                            props.productCode,
                        ),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img
                        src={getProductImage(props.productCode)}
                        alt="product"
                        style={{
                            width: "80%",
                            height: "100%",
                            borderRadius: 8,
                            objectFit: "contain",
                            pointerEvents: "none",
                            userSelect: "none",
                        }}
                    />
                </div>
                <div style={{ marginLeft: theme.MARGIN, flex: 1, minWidth: 0 }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: theme.MARGIN_TINY,
                            marginBottom: theme.MARGIN_SMALL,
                            width: "100%",
                        }}
                    >
                        {props.showRecommendedBadge && (
                            <JuniorPillBadge style={{ alignSelf: "flex-end" }}>
                                {ui.__("gJunior.product.recommended.badge")}
                            </JuniorPillBadge>
                        )}
                        <pr.P_16_TITLE
                            style={{
                                fontWeight: 700,
                                marginBottom: 0,
                            }}
                        >
                            {props.title}
                        </pr.P_16_TITLE>
                    </div>
                    <pr.P_14_CONTENT
                        style={{
                            marginTop: props.isNew ? 0 : theme.MARGIN_SMALL,
                            lineHeight: "20px",
                        }}
                    >
                        {props.description}
                    </pr.P_14_CONTENT>
                    {props.conditions?.chargingInformation && (
                        <div style={{ marginTop: theme.MARGIN_SMALL }}>
                            {props.conditions.chargingInformation.channelText &&
                                props.conditions.chargingInformation.channelText
                                    .length > 0 && (
                                    <pr.P_14_CONTENT
                                        style={{
                                            lineHeight: "20px",
                                            marginTop: theme.MARGIN_SMALL,
                                        }}
                                    >
                                        {props.conditions.chargingInformation.channelText.map(
                                            (text, index) => (
                                                <div key={index}>
                                                    {text.channelFeeText}
                                                </div>
                                            ),
                                        )}
                                    </pr.P_14_CONTENT>
                                )}
                            {props.conditions.chargingInformation
                                .kondiResponse &&
                                props.conditions.chargingInformation
                                    .kondiResponse.length > 0 && (
                                    <div
                                        style={{
                                            marginTop: theme.MARGIN_SMALL,
                                        }}
                                    >
                                        {props.conditions.chargingInformation.kondiResponse
                                            .filter(
                                                (condition) =>
                                                    condition.krzKondardStamm ===
                                                    "HABENZINSEN",
                                            )
                                            .map((condition, index) => {
                                                const translationKey =
                                                    props.productCode ===
                                                    SPARK7_PRODUCT_CODE
                                                        ? "gJunior.product.interestRate.spark7.text"
                                                        : "gJunior.product.interestRate.smartSparen.text";

                                                return (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            marginTop:
                                                                index > 0
                                                                    ? theme.MARGIN_SMALL
                                                                    : 0,
                                                        }}
                                                    >
                                                        <pr.P_14_CONTENT
                                                            style={{
                                                                lineHeight:
                                                                    "24px",
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                                __html: ui.__(
                                                                    translationKey,
                                                                    {
                                                                        interestRate:
                                                                            condition.stzKondition,
                                                                    },
                                                                ),
                                                            }}
                                                        />
                                                        <pr.P_14_CONTENT
                                                            style={{
                                                                lineHeight:
                                                                    "24px",
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                                __html: ui.__(
                                                                    "gJunior.product.fee.text",
                                                                ),
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}
                        </div>
                    )}
                </div>
            </div>
            {props.isNewProduct && (
                <>
                    <div
                        style={{
                            textAlign: "center",
                            marginTop: theme.MARGIN,
                        }}
                    >
                        <GdsFakeActionButton
                            style={{
                                borderRadius: theme.BORDER_RADIUS_FULL,
                                backgroundColor: primaryButtonBg,
                            }}
                            color="primary"
                            fullWidth={isMobile}
                            onClick={props.onOpenAccountButtonCLick}
                        >
                            {ui.__("gJunior.product.openAccount.text")}
                        </GdsFakeActionButton>
                    </div>
                    <div
                        style={{ textAlign: "center", marginTop: theme.MARGIN }}
                    >
                        <JuniorTextButton
                            onClick={props.onProductDetailsClick || (() => {})}
                            style={{
                                fontSize: 14,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                color: linkColor,
                            }}
                        >
                            <pr.IconNewTab
                                style={{
                                    width: 24,
                                    height: 24,
                                    color: linkColor,
                                }}
                            />{" "}
                            <span style={{ marginLeft: 12 }}>
                                {ui.__(
                                    "gJunior.product.showProductDetails.text",
                                )}
                            </span>
                        </JuniorTextButton>
                    </div>
                    {isSpark7 && (
                        <div
                            style={{
                                textAlign: "center",
                                marginTop: theme.MARGIN,
                            }}
                        >
                            <JuniorTextButton
                                onClick={
                                    props.onFeeInformationClick || (() => {})
                                }
                                style={{
                                    fontSize: 14,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                    color: linkColor,
                                }}
                            >
                                <pr.IconDownload
                                    style={{
                                        width: 24,
                                        height: 24,
                                        color: linkColor,
                                    }}
                                />{" "}
                                <span style={{ marginLeft: 12 }}>
                                    {ui.__(
                                        "gJunior.product.feeInformation.text",
                                    )}
                                </span>
                            </JuniorTextButton>
                        </div>
                    )}
                </>
            )}
        </george.Card>
    );
};



// WEBPACK FOOTER //
// ./src/components/gJunior/components/cards/ProductCard.tsx